// @flow
import { put } from './reducers'
import shortId from 'shortid'
import store from '../../store'
import _ from 'lodash'
import type { PersistedMedia } from '../../../components/types'

function putMedia(media: PersistedMedia): string {
  const storeId = shortId.generate()
  store.dispatch(put(storeId, media))
  return storeId
}

function putMedias(medias: Array<PersistedMedia>): Array<string> {
  return _.map(medias, (media) => putMedia(media))
}

export { put, putMedia, putMedias }
